// Vista previa del comprobante de nomina en formato WhatsApp, con descarga en JPG y, en el celular,
// el menu de compartir. Mismo flujo que ModalRecibo.
import { useState } from 'react';
import html2canvas from 'html2canvas';
import NominaCard from './NominaCard';

const slug = t => String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

export default function ModalNominaJpg({ empleado, mesTexto, qTexto, calc, onClose }) {
  const [exportando, setExportando] = useState(false);
  const emitido = new Date().toLocaleDateString('es-CO', { day: 'numeric', month: 'long', year: 'numeric' });
  const nombreArchivo = `comprobante-${slug(empleado?.nombre)}-${slug(mesTexto)}-${slug(qTexto)}-whatsapp.jpg`;

  async function capturar() {
    const el = document.getElementById('nomina-whatsapp-card');
    if (!el) throw new Error('sin tarjeta');
    return html2canvas(el, { backgroundColor: '#ffffff', scale: 2, useCORS: true });
  }
  async function descargarJpg() {
    setExportando(true);
    try {
      const canvas = await capturar();
      const a = document.createElement('a');
      a.href = canvas.toDataURL('image/jpeg', 0.94);
      a.download = nombreArchivo;
      document.body.appendChild(a); a.click(); a.remove();
    } catch (_) { alert('No se pudo generar la imagen del comprobante.'); }
    finally { setExportando(false); }
  }
  async function compartir() {
    setExportando(true);
    try {
      const canvas = await capturar();
      const blob = await new Promise(res => canvas.toBlob(res, 'image/jpeg', 0.94));
      const archivo = new File([blob], nombreArchivo, { type: 'image/jpeg' });
      if (navigator.canShare && navigator.canShare({ files: [archivo] })) {
        await navigator.share({ files: [archivo], title: 'Comprobante de pago', text: `Comprobante de pago · ${empleado?.nombre} · ${qTexto} ${mesTexto}` });
      } else {
        await descargarJpg();
      }
    } catch (err) { if (err?.name !== 'AbortError') alert('No se pudo compartir el comprobante.'); }
    finally { setExportando(false); }
  }
  const puedeCompartir = typeof navigator !== 'undefined' && typeof navigator.share === 'function' && typeof navigator.canShare === 'function';

  return (
    <div className="modal-overlay" style={{ zIndex: 1200 }}>
      <div className="modal" style={{ maxWidth: 480, padding: 18 }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#059669', marginBottom: 4 }}>Comprobante de nómina</div>
        <div style={{ fontSize: 12, color: 'var(--app-muted)', marginBottom: 12 }}>Descarga la imagen para enviarla por WhatsApp. No incluye los aportes del empleador.</div>
        <div style={{ maxHeight: '58vh', overflowY: 'auto', marginBottom: 12, border: '1px solid var(--app-border)', borderRadius: 4 }}>
          <NominaCard empleado={empleado} mesTexto={mesTexto} qTexto={qTexto} emitido={emitido} calc={calc} />
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button type="button" disabled={exportando} className="btn-ui btn-ui--md btn-ui--primary" onClick={descargarJpg}>{exportando ? 'Generando...' : 'Descargar JPG'}</button>
          {puedeCompartir && <button type="button" disabled={exportando} className="btn-ui btn-ui--md btn-ui--dark" onClick={compartir}>Compartir por WhatsApp</button>}
          <button type="button" className="btn-ui btn-ui--md btn-ui--outline" onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
}
